import './about.scss';
import { PhotoFrame, ContentCards, Heading } from '../../components/Reusable/resuable';
import { useAppSelector } from '../../Redux/hook';
import { allImages } from '../../services/images';
import { useState } from 'react';
import { BsTwitterX } from "react-icons/bs";
import { LuFacebook, LuInstagram, LuLinkedin } from "react-icons/lu";
import { leaders } from '../../services/data';
import { Leaders } from '../../models/models';
import { ImageGallery } from '../../services/DataFiles/Gallery/Imagegallery';
import { Helmet } from 'react-helmet-async';
export default function AboutUs() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    const [readMore, setReadMore] = useState(false);
    var listFiles = [
        {
            name: "ISO Certificate",
            pdf: allImages.isocert,
        },
        {
            name: "CSR Policy",
            pdf: allImages.csrpolicy,
        },
        {
            name: "Quality and Safety Policy",
            pdf: allImages.health,
        },
          {
            name: "AGM Notice",
            pdf: allImages.agmNotice,
        },
          {
            name: "Annual Returns",
            pdf: allImages.annualnotice,
        },
          {
            name: "CSR Financial Year 2025-26",
            pdf: allImages.cs2526,
        },
    ];
    var Files = ({ name = "", pdf = "" }) => {
        return <div className='docx'>
            <div className='name'>{name}</div>
            <iframe
                src={`${pdf}#page=1`}
                title="PDF Viewer">
            </iframe>
            <button className='btn btn-primary' onClick={() => window.open(pdf + "#toolbar=0", "_blank")}>View File</button>
        </div>
    }
    var LeaderCard = (leader: Leaders) => {
        return (
            <div className="cards">
                <div className="img">
                    <img src={leader.image} alt="profile" />
                </div>
                <div className="name mt-2">{leader.name}</div>
                <div className="email mb-2" style={{ color: "#0061B1" }}>{leader.email}</div>
                <div className="tag">"{leader.tag}"</div>
                <div className="role">{leader.role}</div>
                {/* <div className="socialmedia">
                    <LuFacebook />
                    <LuInstagram />
                    <LuLinkedin />
                    <BsTwitterX />
                </div> */}
            </div>
        );
    };
    return <div className="aboutus">

        <Helmet>
            <title>About Us - PBL Transport</title>

            <meta
                name="description"
                content="PBL Group is a leading provider of crane, logistics, and transportation services across India. Learn about our legacy, mission, leadership, and commitment to safety and excellence."
            />
            <meta
                name="keywords"
                content="PBL Group, Crane Services, Heavy Transport, Project Cargo, ODC Transport, Logistics India, About PBL, Visakhapatnam, Industrial Transport, Safe Delivery"
            />

            {/* Open Graph for Social Sharing */}
            <meta property="og:title" content="About Us | PBL Group" />
            <meta
                property="og:description"
                content="With over four decades of experience, PBL Group offers innovative logistics and crane solutions across industries including oil & gas, power, mining, and infrastructure."
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://pbltransport.co.in/aboutus" />
            <meta property="og:image" content="https://pbltransport.co.in/static/media/logo.db76c65f9cc9f6a0c58c.png" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="About Us | PBL Group" />
            <meta
                name="twitter:description"
                content="Explore the legacy, mission, values, and leadership of PBL Group – India's trusted name in logistics and crane services."
            />
            <meta name="twitter:image" content="https://pbltransport.co.in/static/media/logo.db76c65f9cc9f6a0c58c.png" />
        </Helmet>

        <ContentCards id={999} image={ImageGallery.cranes.TruckCranes[4].image}
            heading="About Us"
            content="PBL is a name which has become synonymous for safe and satisfied delivery of goods and familiar name for custom made solutions in the industry of transportation and handling across India. Over the years the PBL Group has evolved and grown exponentially to become an organisation to reckon for transportation and handling services. With a rich legacy, a progressive outlook and a consistently superior track record, the Group remains committed towards excellence and delivering satisfaction to its customers." reverse={false} navigate={''} />
        <div className={lightMode ? 'frame' : 'frame mdark'}>
            <div className='para' style={{ marginRight: '50px', marginLeft: '0px' }}>
                <Heading lightMode={lightMode} heading="History" subclass={lightMode ? 'headLight' : 'headLDark'} />
                <div className='desContent'>
                    <div>In the year of 1980 the PBL Group has started its operations in Visakhapatnam with a motto of successful and safe transportation of goods and to provide an ultimate quality services to its customers with custom made solutions to deliver satisfaction to its customers.</div>
                    <br />
                    <div>Over the years the company had grown and in the year of 1995 the sister concern in the name of PBL Transport Corporation Private Limited has started its operations and evolving into a large business House. The PBL Group is a dynamic enterprise which draws vital support from its various individual entities and associates to be able to execute turnkey transportation, project cargo transportation, swiftly and efficiently. Due to the prompt services and personal attention to the clients, the company has received an overwhelming response from the market. The competence in project transportation is well proven in major industries operating in core sectors like Engineering, Oil & Gas, Power, Refineries, Chemicals, Cement, etc. We believe that performance speaks louder than words and that’s why the company sincerely follows client-centric approaches that flow from everything the company do and offer. Our impeccable track record in successfully handling the transportation of critical products has helped us win the trust of innumerable clients operating in the production of sensitive products.</div>
                    <br />
                    <div>PBL Transport Corporation Private Limited has carved a special niche for itself in the arena of logistics and transport services. Our in-depth expertise in the discipline has helped us offer all types of transportation services ranging from Trip Load consignment to the ODC (over dimensional) transportation and Project Cargo Transportation.</div>
                </div>
                <div className='mobContent'>
                    {readMore ? <div></div> : <div>In the year of 1980 the PBL Group has started its operations in Visakhapatnam with a motto of successful and safe transportation of goods and to provide an ultimate quality services to its customers with custom made solutions to deliver satisfaction to its customers...<span onClick={() => setReadMore(!readMore)}>Read More</span></div>}
                    {!readMore ? <div></div> : <div>
                        <div>In the year of 1980 the PBL Group has started its operations in Visakhapatnam with a motto of successful and safe transportation of goods and to provide an ultimate quality services to its customers with custom made solutions to deliver satisfaction to its customers.</div>
                        <br />
                        <div>Over the years the company had grown and in the year of 1995 the sister concern in the name of PBL Transport Corporation Private Limited has started its operations and evolving into a large business House. The PBL Group is a dynamic enterprise which draws vital support from its various individual entities and associates to be able to execute turnkey transportation, project cargo transportation, swiftly and efficiently. Due to the prompt services and personal attention to the clients, the company has received an overwhelming response from the market. The competence in project transportation is well proven in major industries operating in core sectors like Engineering, Oil & Gas, Power, Refineries, Chemicals, Cement, etc. We believe that performance speaks louder than words and that’s why the company sincerely follows client-centric approaches that flow from everything the company do and offer. Our impeccable track record in successfully handling the transportation of critical products has helped us win the trust of innumerable clients operating in the production of sensitive products.</div>
                        <br />
                        <div>PBL Transport Corporation Private Limited has carved a special niche for itself in the arena of logistics and transport services. Our in-depth expertise in the discipline has helped us offer all types of transportation services ranging from Trip Load consignment to the ODC (over dimensional) transportation and Project Cargo Transportation....<span onClick={() => setReadMore(!readMore)}>Read less</span></div>
                    </div>}
                </div>
                <img className='mobImage' src={allImages.history} alt='logo' />
            </div>
            <PhotoFrame image={allImages.history} fHeight='700px' height={645} />
        </div>
        <center><Heading lightMode={lightMode} heading="Our Mission, Vision, & Values" /></center>
        <div className='values'>
            <div className="card">
                <div className='back'>
                    <p>
                        <center className='head'>Mission</center>
                        <ul>
                            <li>We aim to provide innovative, practical, and top-quality logistic services that improve business solutions.</li>
                            <li>Our Roadmap is to add value to clients and business partners through the consistent pursuit of excellence and commitment to our values.</li>
                            <li>To maintain the highest level of integrity and continue to utilize all of our resources solely for the betterment of the organization.</li>
                            <li>We constantly endeavor to provide our employees with a stimulating yet secure working environment where their individual talents are embraced and nurtured.</li>
                        </ul>
                    </p>
                </div>
                <div className='front'>
                    <div className='head'>Mission</div>
                    <img src={allImages.mission} alt='mission' />
                </div>
            </div>
            <div className='card'>
                <div className='back'>
                    <p>
                        <center className='head'>Vision</center>
                        To be recognized as an organization that provides qualitatively a comprehensive range of strategic transportation.</p>
                </div>
                <div className='front'>
                    <div className='head'>Vision</div>
                    <img src={allImages.vision} alt='vision' />
                </div>
            </div>
            <div className='card'>
                <div className='back'>
                    <p>
                        <center className='head'>Values</center>

                        <ul>
                            <li>We treat our associates, clients, and employees with honesty and integrity. We stand by our commitments consistently.</li>
                            <li>We follow the philosophy that open communication is conducive to trustworthy and enduring productive relationships.</li>
                            <li>We strive to be good corporate citizens, focused on safety, family values, and quality of life, making a positive difference in our communities.</li>
                            <li>We provide our Clients, Vendors, and Associates an environment that encourages teamwork and shares the rewards.</li>
                            <li>And in quality; what we do, we do well.</li>
                        </ul>
                    </p>
                </div>
                <div className='front'>
                    <div className='head'>Values</div>
                    <img src={allImages.values} alt='values' />
                </div>
            </div>
        </div>
        <center><Heading lightMode={lightMode} heading="Meet Our Leaders" /></center>
        <div className='leaders'>
            {leaders.map((item, index) => (
                <LeaderCard key={index} {...item} />
            ))}
        </div>
        <center><Heading lightMode={lightMode} heading="Documents" /></center>
        <div className='files'>
            {listFiles.map((item, index) => (
                <Files key={index} {...item} />
            ))}
        </div>
    </div>
}